// extracted by mini-css-extract-plugin
export default {"popup":"ModalOverlay_popup__2bExb","flareAnimation":"ModalOverlay_flareAnimation__yCDL7","shine":"ModalOverlay_shine__fpn46"};